import React from 'react';
import LeafletMap from '../../../../../../common/src/components/leaflet-map/LeafletMap';
import { useBreakpointValue, Box } from '@wegroup/design-system';
import { useFlowsSelector } from '../../../../../../common/src/utils/globalVariables';
import useAddressForLeafletMap from '../hooks/useAddressForLeafletMap';

const HomeQuestionMap: React.FC<React.PropsWithChildren<unknown>> = () => {
  const initialZoom = useBreakpointValue({ base: 18, desktopS: 19 });
  const answers = useFlowsSelector((state) => state.flows.answers);
  const flowId = useFlowsSelector((state) => state.flows?.metaData?.flowId);

  const { coords, address, isLoading } = useAddressForLeafletMap({
    answers,
    flowId,
  });

  return (
    <Box
      position="absolute"
      w="calc(100% + 28px)"
      h="100%"
      left="-28px"
      top="0"
    >
      <LeafletMap
        initialZoom={initialZoom}
        centerCoords={{
          lat: address?.lat || 51.03,
          lng: address?.lng || 3.7377,
        }}
        centerAlignment="right"
        markerCoords={coords}
        isLoading={isLoading || !(address?.lat && address?.lng)}
        isSatelliteDefault
        withOptionsMenu
        withZoomControls
      />
    </Box>
  );
};

export default HomeQuestionMap;
